  <div *ngIf="(this.mls.featureOnOffList.moduleList.CALENDAR.value || !mls.userLoginFlow)">
  <div class="position-relative">

    <!-- @@ START  WEB PROFILE POST@@      *ngIf = "dss.user_profile_data.user_connection.total_connections!=0 && dss.user_profile_data.user_connection.total_connections != undefined " -->
    <div class="">
      <!-- connection request -->
      <div class="connection-card mb-4">
        <app-connection-request-list [limit]=5 [location]='"gr"'
          [callingfrom]="'grandround'">
        </app-connection-request-list>
      </div>
      <div>
        <app-docquity-tele-consulting  
          [userTrackId]="this.dss.user_profile_data?.profile?.track_id"></app-docquity-tele-consulting>
      </div>
      <div class="bg-white border-card mb-2 d-none d-lg-block">
        <app-calender-event [callingfrom]="'suggestionRight'"></app-calender-event>
        <div class="ps position-relative">
          <app-event-list [callingfrom]="'suggestionRight'"></app-event-list>
        </div>
      </div>
      <!-- end connection request -->
      <div class="clearfix"></div>
      <!-- cases -->
      <app-top-cases></app-top-cases>
      <!-- end cases -->
      <div class="mb-3 rounded" *ngIf="product_type!=3 && user_profile_card!=undefined">
        <div class="text-center w-100 d-inline-block bg-info p-5 rounded">
          <div class="mb-3 d-inline-block">
            <img src="./assets/images/web-profile.png" width="94" height="63">
          </div>
          <div>
            <h4 class="heading-4">{{user_profile_card?.product?.profile?.userProfilePercentage?.primaryText}}</h4>
            <span>{{user_profile_card?.product?.profile?.userProfilePercentage?.secondaryText}}</span>
            <div class="progress__bar">
              <div class="progress__bar_fill"
                [ngStyle]="{'width': user_profile_card?.product?.profile?.userProfilePercentage?.percentage+'%'}"></div>
              <span class="progress__count">{{user_profile_card?.product?.profile?.userProfilePercentage?.percentage}}%</span>
            </div>
            <a href="javascript:(void)" (click)="navifateToProfile()">{{mls?.languageText?.suggestion_right?.key3}}
              <span *ngIf="mls?.is_lskey_display == 1">(suggestion_right.key3)</span>
            </a>
          </div>
        </div>
      </div>

      <!-- @@ START WEB PROFILE POST@@ -->
      <div class="d-none" *ngIf="suggestionList.length>0">
        <div class="bg-white rounded mb-3">
          <div class="p-2 border-bottom">
            <p>{{mls?.languageText?.suggestion_right?.key1}}
              <span *ngIf="mls?.is_lskey_display == 1">(suggestion_right.key1)</span>
            </p>
          </div>
          <div>
            <ul class="clearfix">
              <li *ngFor="let sL of suggestionList">
                <div (click)="navToCmeSection(sL.course_id);"
                  [eventTracker]='{"category":screen_name,"action":ems.SuggestionRightComponent.trending_cme,"product_type":product_type,"product_id":sL.course_id}'>
                  <div class="clearfix">
                    <div>
                      <img src="{{sL.accreditation_url}}" alt="">
                    </div>
                    <div>

                      <h4 class="heading-4">{{sL.accreditation}}</h4>
                      <p [innerHTML]="sL.title | dotedAfterSlice:55 | safehtml"></p>
                      <p><span>
                          <p>{{mls?.languageText?.suggestion_right?.key2}}<span
                              *ngIf="mls?.is_lskey_display == 1">(suggestion_right.key2)</span> : {{sL.total_points}}
                        </span> <small></small> {{ sL.end_date | date:'mediumDate' }}</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- verify -->
      <div class="bg-white border mb-3" id="readonlycase" *ngIf="user_verification_data!=undefined">
        <div class="border rounded clearfix p-3">
          <div class="verify-logo">
            <img class="float-left" src="assets/images/verify-img.png" alt="verify" width="70" height="70">
          </div>
          <div class="pl-">
            <h4 class="heading-5">{{mls?.languageText?.suggestion_right?.key4}}
              <span *ngIf="mls?.is_lskey_display == 1">(suggestion_right.key4)</span>
            </h4>
            <p class="primary-small">{{mls?.languageText?.suggestion_right?.key5}}<span
                *ngIf="mls?.is_lskey_display == 1">(suggestion_right.key5)</span> </p>
            <a href="javascript:(void)" class="primary-small color-white mt-3 verifyNow ">
              <i class="fa fa-refresh fa-spin button-loader" *ngIf="act_loader==true"></i>
              {{mls?.languageText?.suggestion_right?.key6}}
              <span *ngIf="mls?.is_lskey_display == 1">(suggestion_right.key6)</span> </a>
          </div>
        </div>
      </div>
      <!-- end verify -->
    </div>
  </div>

  <app-info-modal (resetInfoModal)=resetInfoModal() [isInfoModalShown]=isInfoModalShown [info_msg]=info_msg>
  </app-info-modal>

</div>